import { NICmsContentComponent } from '@icms/core/content';

export namespace NCheckoutAccountNewCms {
    export const BLOCK_ID = 'checkout-account-new-cms';

    export interface IData extends NICmsContentComponent.IData {
        // Main blocks configuration
        blocks?: IBlock[];
        termsAndConditions?: string;
    }

    export interface IBlock {
        type: 'guest_checkout' | 'sign_in' | 'create_account' | 'separator';
        title: string;
        copy?: string;
        ctaText: string;
        ctaStyle?: string;
        selectedTitle?: string;
        selectedCopy?: string;
        selectedCtaText?: string;
        selectedCtaStyle?: string;
        enabled: boolean;
        backgroundColor?: string;
    }
}
